

// import React, { useEffect, useState } from "react";
// import { useParams, Link } from "react-router-dom";
// import { servicesData } from "./ServicesData";
// import { Phone, Mail, Send } from "lucide-react";
// import { Helmet } from "react-helmet";
// import Header from "../../layout/Header";
// import Footer from "../../layout/Footer";

// const ServicesDetail = () => {
//   const { serviceId } = useParams();
//   const service = servicesData.find((s) => s.id === serviceId);

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     topic: service?.title || "",
//     message: "",
//   });

//   const [success, setSuccess] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     setFormData((prev) => ({ ...prev, topic: service?.title || "" }));
//   }, [service]);

//   useEffect(() => {
//     const handleEsc = (e) => {
//       if (e.key === "Escape") setSelectedItem(null);
//     };
//     window.addEventListener("keydown", handleEsc);
//     return () => window.removeEventListener("keydown", handleEsc);
//   }, []);

//   if (!service)
//     return (
//       <div className="py-40 text-center text-2xl">
//         Service Not Found
//       </div>
//     );

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "phone" && (value.length > 10 || /[^0-9]/.test(value))) return;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     if (!formData.name || !formData.email || formData.phone.length !== 10) {
//       alert("Please fill all fields correctly!");
//       return;
//     }

//     const waMessage = `Hello! I am interested in ${formData.topic}
// Name: ${formData.name}
// Email: ${formData.email}
// Phone: ${formData.phone}
// Message: ${formData.message}`;

//     window.open(
//       `https://wa.me/919625975135?text=${encodeURIComponent(waMessage)}`,
//       "_blank"
//     );

//     setSuccess(true);

//     setFormData({
//       name: "",
//       email: "",
//       phone: "",
//       topic: service.title,
//       message: "",
//     });

//     setTimeout(() => setSuccess(false), 3000);
//   };

//   return (
//     <>
//       <Helmet>
//         <title>{service.helmetTitle}</title>
//         <meta name="description" content={service.helmetDescription} />
//         <meta name="keywords" content={service.helmetKeywords} />
//       </Helmet>

//       <Header />

//       <div className="bg-[#f4f7f6] font-serif">

//         {/* HERO */}
//         <div
//           className="relative h-[400px] sm:h-[450px] md:h-[500px] flex items-center justify-center bg-cover bg-center"
//           style={{
//             backgroundImage: `linear-gradient(rgba(11,28,45,0.7),rgba(11,28,45,0.7)), url(${service.bannerImage})`,
//           }}
//         >
//           <div className="text-center px-4">
//             <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl text-white font-bold mb-4">
//               {service.title}
//             </h1>

//             <div className="flex justify-center gap-2 text-gray-300 text-xs sm:text-sm uppercase">
//               <Link to="/" className="hover:text-[#d4a373]">Home</Link>
//               <span>/</span>
//               <span>{service.title}</span>
//             </div>
//           </div>
//         </div>

//         {/* MAIN */}
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-20">
//           <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">

//             {/* LEFT */}
//             <div className="lg:col-span-2 space-y-12">

//               <div>
//                 <h2 className="text-2xl sm:text-3xl font-bold text-[#002b1f] mb-4">
//                   About {service.title}
//                 </h2>
//                 <p className="text-gray-600 leading-relaxed text-sm sm:text-base">
//                   {service.fullDesc?.intro}
//                 </p>
//               </div>

//               {service.fullDesc?.sections?.map((section, i) => (
//                 <div key={i} className="space-y-4">
//                   <h3 className="text-xl sm:text-2xl font-bold text-[#002b1f]">
//                     {section.title}
//                   </h3>

//                   {section.content && (
//                     <p className="text-gray-600 text-sm sm:text-base">
//                       {section.content}
//                     </p>
//                   )}


//                   {section.list && (
//                     <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//                       {section.list.map((item, idx) => (
//                         <div key={idx} className="bg-white p-4 rounded-lg shadow">
//                           {item}
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               ))}

//               <div>
//                 <h3 className="text-xl sm:text-2xl font-bold text-[#002b1f] mb-6">
//                   Case Highlights
//                 </h3>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//                   {service.featureDetails?.map((item, i) => (
//                     <div
//                       key={i}
//                       onClick={() => setSelectedItem(item)}
//                       className="bg-white rounded-xl shadow hover:shadow-xl cursor-pointer transition"
//                     >
//                       <img
//                         src={item.img}
//                         className="h-40 sm:h-48 w-full object-cover rounded-t-xl"
//                       />
//                       <div className="p-4">
//                         <h4 className="font-bold text-sm sm:text-base">
//                           {item.name}
//                         </h4>
//                         <p className="text-xs sm:text-sm text-gray-500">
//                           {item.desc}
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>

//             </div>

//             {/* RIGHT (FIXED) */}
//             <div className="lg:col-span-1">
//               <div className="sticky top-28 space-y-8">

//                 {/* FORM */}
//                 <div className="bg-[#0B1C2D] rounded-2xl p-8 text-white shadow-2xl border-b-4 border-[#d4a373]">
//                   <h3 className="text-2xl font-bold mb-2 text-[#d4a373] uppercase">
//                     Free Consultation
//                   </h3>

//                   <form className="space-y-4" onSubmit={handleSubmit}>
//                     <input
//                       type="text"
//                       name="name"
//                       placeholder="Your Full Name"
//                       value={formData.name}
//                       onChange={handleChange}
//                       className="w-full bg-white/5 border border-white/10 p-3 rounded-lg"
//                       required
//                     />
//                     <input
//                       type="email"
//                       name="email"
//                       placeholder="Email Address"
//                       value={formData.email}
//                       onChange={handleChange}
//                       className="w-full bg-white/5 border border-white/10 p-3 rounded-lg"
//                       required
//                     />
//                     <input
//                       type="tel"
//                       name="phone"
//                       placeholder="Phone Number"
//                       value={formData.phone}
//                       onChange={handleChange}
//                       className="w-full bg-white/5 border border-white/10 p-3 rounded-lg"
//                       required
//                     />
//                     <textarea
//                       name="message"
//                       rows="4"
//                       placeholder="How can we help you?"
//                       value={formData.message}
//                       onChange={handleChange}
//                       className="w-full bg-white/5 border border-white/10 p-3 rounded-lg"
//                     />
//                     <button
//                       type="submit"
//                       className="w-full bg-[#d4a373] text-[#002b1f] font-bold py-3 rounded-lg flex items-center justify-center gap-2"
//                     >
//                       SEND MESSAGE <Send size={18} />
//                     </button>
                    
//                   </form>
//                 </div>

//                 {/* CONTACT */}
//                 <div className="bg-white p-6 rounded-2xl shadow">
//                   <div className="flex items-center gap-2">
//                     <Phone size={16} /> +91 96259 75135
//                   </div>
//                   <div className="flex items-center gap-2 mt-2">
//                     <Mail size={16} /> arunchaudhri1258@gmail.com
//                   </div>
//                 </div>

//               </div>
//             </div>

//           </div>
//         </div>

//         {/* POPUP */}
//         {selectedItem && (
//           <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
//             <div className="bg-white max-w-md w-full rounded-xl overflow-hidden relative">
//               <button
//                 onClick={() => setSelectedItem(null)}
//                 className="absolute top-3 right-3 bg-black text-white px-2 rounded"
//               >
//                 ✕
//               </button>

//               <img src={selectedItem.img} className="w-full h-60 object-cover"/>
//               <div className="p-4">
//                 <h2 className="font-bold">{selectedItem.name}</h2>
//                 <p>{selectedItem.desc}</p>
//               </div>
//             </div>
//           </div>
//         )}

//       </div>

//       <Footer />
//     </>
//   );
// };

// export default ServicesDetail;

import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { servicesData } from "./ServicesData";
import { Phone, Mail, Send, ChevronRight, CheckCircle2, Globe } from "lucide-react";
import { Helmet } from "react-helmet";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";

const ServicesDetail = () => {
  const { serviceId } = useParams();
  const service = servicesData.find((s) => s.id === serviceId);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    topic: service?.title || "",
    message: "",
  });

  const [success, setSuccess] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    setFormData((prev) => ({ ...prev, topic: service?.title || "" }));
  }, [service]);

  if (!service) return <div className="py-40 text-center text-white bg-[#050505] h-screen font-light tracking-widest uppercase">Service Not Found</div>;

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone" && (value.length > 10 || /[^0-9]/.test(value))) return;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const waMessage = `Interest: ${formData.topic}\nName: ${formData.name}\nPhone: ${formData.phone}\nMessage: ${formData.message}`;
    window.open(`https://wa.me/918447220987?text=${encodeURIComponent(waMessage)}`, "_blank");
    setSuccess(true);
    setTimeout(() => setSuccess(false), 3000);
  };

  return (
    <div className="bg-[#050505] text-gray-400 min-h-screen selection:bg-[#B68D40] selection:text-black font-sans antialiased">
      <Helmet>
        <title>{service.helmetTitle}</title>
      </Helmet>

      <Header />

      {/* --- REFINED HERO SECTION --- */}
      <div className="relative h-[70vh] flex items-end pb-24 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src={service.bannerImage} 
            className="w-full h-full object-cover grayscale-[40%] brightness-50 transition-transform duration-1000 hover:scale-110" 
            alt="Banner"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/40 to-transparent" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,#050505_100%)] opacity-60" />
        </div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
          <nav className="flex items-center gap-3 text-white/50 text-[11px] font-bold mb-8 uppercase tracking-[0.3em]">
            <Link to="/" className="hover:text-[#B68D40] transition-colors">Home</Link>
            <span className="opacity-30">/</span>
            <span className="text-[#B68D40]">{service.title}</span>
          </nav>
          <h1 className="text-6xl md:text-9xl font-black text-white leading-[0.9] tracking-tighter uppercase italic">
            {service.title.split(' ').map((word, i) => (
              <span key={i} className={i % 2 !== 0 ? "text-[#B68D40] block md:inline" : "block md:inline"}>{word} </span>
            ))}
          </h1>
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-6 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-20">
          
          {/* --- CONTENT AREA (LEFT) --- */}
          <div className="lg:col-span-8 space-y-32">
            
            {/* INTRO Section */}
            <section className="relative group">
              <div className="absolute -left-8 top-0 w-[2px] h-0 bg-[#B68D40] transition-all duration-700 group-hover:h-full" />
              <h2 className="text-xs font-bold text-[#B68D40] mb-6 uppercase tracking-[0.5em]">Overview</h2>
              <p className="text-2xl md:text-3xl text-white/90 leading-snug font-light italic text-justify">
                "{service.fullDesc?.intro}"
              </p>
            </section>

            {/* FEATURES BENTO GRID */}
            {service.fullDesc?.sections?.map((section, i) => (
              <section key={i} className="space-y-12">
                <div className="flex items-baseline gap-6 border-b border-white/5 pb-6">
                  <span className="text-[#B68D40] font-serif italic text-3xl opacity-50">0{i + 1}</span>
                  <h3 className="text-3xl font-bold text-white tracking-tight">{section.title}</h3>
                </div>

                {section.content && <p className="text-lg text-gray-400 text-justify leading-relaxed max-w-2xl">{section.content}</p>}

                {section.list && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5 border border-white/5 overflow-hidden rounded-sm">
                    {section.list.map((item, idx) => (
                      <div key={idx} className="group flex items-start gap-5 p-8 bg-[#050505] hover:bg-[#0A0A0A] transition-colors">
                        <div className="p-1 rounded-full border border-[#B68D40]/30 text-[#B68D40]">
                            <CheckCircle2 size={14} />
                        </div>
                        <span className="text-sm font-medium text-gray-300 group-hover:text-white transition-colors">{item}</span>
                      </div>
                    ))}
                  </div>
                )}
              </section>
            ))}

            {/* CASE STUDIES HIGHLIGHT */}
            <section className="space-y-12">
                <h3 className="text-xs font-bold text-[#B68D40] uppercase tracking-[0.5em]">Selected Works</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {service.featureDetails?.map((item, i) => (
                    <div
                      key={i}
                      onClick={() => setSelectedItem(item)}
                      className="group relative aspect-[4/5] overflow-hidden bg-neutral-900 cursor-pointer"
                    >
                      <img
                        src={item.img}
                        className="w-full h-full object-cover opacity-60 grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:opacity-100 transition-all duration-1000"
                        alt={item.name}
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent p-8 flex flex-col justify-end">
                        <h4 className="text-xl font-bold text-white translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                          {item.name}
                        </h4>
                        <p className="text-xs text-[#B68D40] opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100 mt-2 uppercase tracking-widest">View Project</p>
                      </div>
                      <div className="absolute top-8 right-8 mix-blend-difference">
                         <Globe size={20} className="text-white" />
                      </div>
                    </div>
                  ))}
                </div>
            </section>
          </div>

          {/* --- SIDEBAR (RIGHT) --- */}
          <div className="lg:col-span-4">
            <div className="sticky top-32 space-y-12">
              
              {/* CONTACT FORM CARD */}
              <div className="relative">
                <div className="bg-[#0A0A0A] border border-white/5 p-10 rounded-sm">
                  <h3 className="text-2xl font-bold text-white mb-2 italic">Consultation</h3>
                  <p className="text-[10px] text-gray-500 mb-10 uppercase tracking-widest border-b border-white/5 pb-4">Subject: {service.title}</p>

                  <form className="space-y-8" onSubmit={handleSubmit}>
                    <div className="relative group">
                        <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full bg-transparent border-b border-white/10 py-3 text-white focus:border-[#B68D40] outline-none transition-colors peer"
                        placeholder=" "
                        required
                        />
                        <label className="absolute left-0 top-3 text-xs uppercase tracking-widest text-gray-600 pointer-events-none transition-all peer-focus:-top-4 peer-focus:text-[#B68D40] peer-[:not(:placeholder-shown)]:-top-4">Name</label>
                    </div>
                    
                    <div className="relative group">
                        <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full bg-transparent border-b border-white/10 py-3 text-white focus:border-[#B68D40] outline-none transition-colors peer"
                        placeholder=" "
                        required
                        />
                        <label className="absolute left-0 top-3 text-xs uppercase tracking-widest text-gray-600 pointer-events-none transition-all peer-focus:-top-4 peer-focus:text-[#B68D40] peer-[:not(:placeholder-shown)]:-top-4">Phone</label>
                    </div>

                    <textarea
                      name="message"
                      rows="3"
                      value={formData.message}
                      onChange={handleChange}
                      className="w-full bg-white/5 border border-white/5 p-4 text-sm text-white focus:border-[#B68D40]/50 outline-none transition-all resize-none"
                      placeholder="Briefly describe your vision..."
                    />

                    <button
                      type="submit"
                      className="w-full bg-white text-black font-bold py-5 text-xs uppercase tracking-[0.3em] flex items-center justify-center gap-4 hover:bg-[#B68D40] hover:text-white transition-all duration-500"
                    >
                      Initialize <Send size={14} />
                    </button>
                    {success && <p className="text-center text-[10px] text-[#B68D40] tracking-widest uppercase animate-pulse">Routing to WhatsApp...</p>}
                  </form>
                </div>
              </div>

              {/* INFO BOX */}
              <div className="space-y-6 px-4">
                <div className="flex items-center gap-6 group cursor-pointer">
                    <Phone size={16} className="text-[#B68D40] opacity-50 group-hover:opacity-100 transition-opacity" />
                    <div>
                        <p className="text-[9px] uppercase text-gray-600 tracking-tighter">Direct Line</p>
                        <p className="text-white text-sm font-medium group-hover:text-[#B68D40] transition-colors">+91 98181 04905</p>
                    </div>
                </div>
                <div className="flex items-center gap-6 group cursor-pointer">
                    <Mail size={16} className="text-[#B68D40] opacity-50 group-hover:opacity-100 transition-opacity" />
                    <div>
                        <p className="text-[9px] uppercase text-gray-600 tracking-tighter">Official Email</p>
                        <p className="text-white text-sm font-medium group-hover:text-[#B68D40] transition-colors break-all">Shailendrakumarsingh9818@gmail.com</p>
                    </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </main>

      {/* --- REFINED LIGHTBOX POPUP --- */}
      {selectedItem && (
        <div className="fixed inset-0 bg-[#050505]/95 backdrop-blur-xl flex items-center justify-center z-[100] p-4">
          <div className="bg-[#0A0A0A] max-w-4xl w-full border border-white/10 relative overflow-hidden shadow-2xl">
            <button
              onClick={() => setSelectedItem(null)}
              className="absolute top-8 right-8 z-20 text-white/50 hover:text-[#B68D40] transition-colors text-2xl font-light"
            >
              ✕
            </button>
            <div className="grid md:grid-cols-2">
                <img src={selectedItem.img} className="w-full h-full min-h-[400px] object-cover grayscale-[20%]" alt="Detail" />
                <div className="p-12 flex flex-col justify-center">
                    <h2 className="text-xs font-bold text-[#B68D40] mb-4 uppercase tracking-[0.4em]">Project Detail</h2>
                    <h3 className="text-3xl font-bold text-white mb-6 italic">{selectedItem.name}</h3>
                    <p className="text-gray-400 leading-relaxed font-light">{selectedItem.desc}</p>
                    <button onClick={() => setSelectedItem(null)} className="mt-10 text-[10px] uppercase tracking-widest text-white border-b border-[#B68D40] w-fit pb-1 hover:text-[#B68D40] transition-colors">Return to Services</button>
                </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default ServicesDetail;